import React from 'react';
import {
  // eslint-disable-next-line no-restricted-imports
  Text as RNText,
  TextProps as RNTextProps,
  TextStyle,
  StyleProp,
  GestureResponderEvent,
} from 'react-native';
import { IS_ANDROID } from '@/utils/platform';

import { styles } from './styles';

interface TextProps extends RNTextProps {
  className?: string;
  isResponsiveText?: boolean;
  style?: StyleProp<TextStyle>;
  ref?: React.ForwardedRef<RNText>;
  children: React.ReactNode;
  onPress?: (event: GestureResponderEvent) => void;
}

export const Text: React.FC<TextProps> = ({
  className,
  style,
  ref,
  children,
  onPress,
}) => {
  return (
    <RNText
      onPress={onPress}
      className={className}
      style={[styles.defaultText, style]}
      ref={ref}
    >
      {children}
      {IS_ANDROID && ' '}
    </RNText>
  );
};
